import React, { useEffect } from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import { FaTable } from "react-icons/fa";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import TextField from "components/ui/controls/text-field/text-field";
const VersementMadelin = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);
  let Year = new Date().getFullYear();
  const Today = new Date();
  let AnneeDebut = Today.getFullYear();
  let AnneeFin = context.state["DateDepartRetraite" + ClientConjoint].slice(-4);
  if (context.state.PayeurPrimeRetraite === "Entreprise") {
    AnneeFin = context.state["FinPeriodeCarriereActuelle" + ClientConjoint].slice(-4);
  }
  if (props.AccessRemExpress === true) {
    AnneeFin = AnneeDebut + 1;
  }
  useEffect(() => {
    if (Object.keys(context.state.CotisationContratRetraite).length === 0) {
      let TableauVersement = {};
      for (var Annee = AnneeDebut; Annee <= Number(AnneeFin); Annee++) {
        let Versement = {
          [Annee]: {
            Versement: 0,
            VersementSaisi: false,
          },
        };
        TableauVersement = { ...TableauVersement, ...Versement };
      }
      context.handleValueChange("CotisationContratRetraite", TableauVersement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>      <Column fill>
        <CardBox bpad>
          <Column fill>
            <div className="dossier-header">
              <div className="dossier-header-icon">
                <FaTable style={{ fontSize: "14px", color: "#6b7280" }} />
              </div>
              <div className="dossier-header-title"> Tableau des versements périodiques</div>
            </div>
            {props.AccessRemExpress === false && (
              <Row style={{ marginTop: 8, maxWidth: 600 }}>
                <Column>
                  <TextField
                    label="Taux d'indexation"
                    value={context.state.TauxIndexationContratRetraite}
                    onChange={context.handleCalculEvolutionContrat}
                    dataType="ufloat"
                    format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                    normal
                  />
                </Column>
              </Row>
            )}
            <Row>
              <Column fill>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    width: "100%",
                    maxWidth: 572,
                    marginLeft: 0,
                    marginRight: 0,
                    display: "block",
                  }}
                >
                  {Object.keys(context.state.CotisationContratRetraite)
                    .filter((Annee) => Annee >= Year && Annee <= AnneeFin)
                    .map((Annee, index, arr) => (
                      <li
                        key={Annee}
                        style={{
                          background: "#fff",
                          borderRadius: "12px",
                          boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                          padding: "14px 18px",
                          marginBottom: "14px",
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          border: "1.5px solid #d1d5db", // gris clair
                          transition: "box-shadow 0.2s",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 700,
                            fontSize: "12px",
                            color: "#6366f1",
                            fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                            minWidth: 70,
                            marginRight: 18,
                            background: "#f1f5ff",
                            border: "1.5px solid #6366f1",
                            borderRadius: "8px",
                            padding: "4px 12px",
                            display: "inline-block",
                          }}
                        >
                          Année {Annee}
                        </span>
                        <TextField
                          value={context.state.CotisationContratRetraite[Annee]["Versement"]}
                          dataType="uint"
                          format={{ thousands: " ", unit: " €" }}
                          onChange={(e) => {
                            context.handleVersementContrat(Annee, e.target.value);
                          }}
                          style={{
                            width: "120px",
                            fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                            background: "#fff",
                            border: "1.5px solid #d1d5db", // gris clair
                            borderRadius: "8px",
                            padding: "6px 10px",
                            color: "#1e293b",
                            boxShadow: "0 1px 3px rgba(99,102,241,0.06)",
                            outline: "none",
                            transition: "border 0.2s",
                            marginRight: 18,
                          }}
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#64748b",
                            fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                            flex: 1,
                          }}
                        >
                          Montant annuel à verser
                        </span>
                      </li>
                    ))}
                </ul>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
};

export default VersementMadelin;
